import { useState, useEffect } from 'react';

import { learningPathApi } from '../api';
import type { LearningPathConfigResponse } from '../types';

export interface UseLearningPathConfigResult {
  config: LearningPathConfigResponse | null;
  loaded: boolean;
}

/**
 * Fetches the learning path config once on mount. `loaded` flips true on both
 * success and error so callers can distinguish "still fetching" from
 * "fetched but empty" (needed for gating UI without flashing the error state).
 */
export const useLearningPathConfig = (): UseLearningPathConfigResult => {
  const [config, setConfig] = useState<LearningPathConfigResponse | null>(null);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    learningPathApi.getLearningPathConfig(
      (data) => {
        setConfig(data);
        setLoaded(true);
      },
      () => setLoaded(true),
    );
  }, []);

  return { config, loaded };
};
